/** @jsx jsx */
import { jsx } from '@emotion/core'
import { observer } from 'mobx-react'
import {
  formatCreatedAtToElapsedTime,
} from '@utils/utils'
import { CheerForTeamListItem } from '@views/Matchup/MatchUpDetail/index.style'
import { LogoWingIco } from '@shared/Icon/LogoIcon'
import { MatchStatusTag } from '@components/MatchStatusTag'
import useRootStore from '@store/useRootStore'
import { Schema$MatchTimeLineAll } from '@interface/matchup'
import { TimelineEventType } from '@interface/chat'
import { MATCH_STATUS, SPORT_ID } from 'adv-protocol/src/GameCommon'
import _ from 'lodash'

export interface AdvTimelineItemProps {
  advTimeline: Schema$MatchTimeLineAll,
}

export const AdvTimelineItem: React.FC<AdvTimelineItemProps> = observer((props: AdvTimelineItemProps) => {
  const { advTimeline } = props
  const { matchupStore } = useRootStore()
  const { detailTrack } = matchupStore
  const { track } = detailTrack

  const sportId = detailTrack.sportId
  const homeTeamName = track?.homeTeamName
  const awayTeamName = track?.awayTeamName
  const homeScore = advTimeline.homeScore || 0
  const awayScore = advTimeline.awayScore || 0

  const getPeriodNameBySportId = (sportId: number, period: number) => {
    let periodName = ''
    if (sportId === SPORT_ID.SOCCER) {
      periodName = period === 1 ? '전반전' : '후반전'
    } else if (sportId === SPORT_ID.VOLLEYBALL || sportId === SPORT_ID.TABLE_TENNIS) {
      periodName = `${period}세트`
    } else if (sportId === SPORT_ID.BASEBALL) {
      periodName = `${period}이닝`
    } else if (sportId === SPORT_ID.BASKETBALL) {
      periodName = `${period}쿼터`
    } else if (sportId === SPORT_ID.ICE_HOCKEY) {
      periodName = `${period}피리어드`
    }

    return periodName
  }

  let matchStatusName: string
  const timelineType = advTimeline.type
  const timelineMatchStatus = _.toNumber(advTimeline.matchStatus)

  if (timelineType === TimelineEventType.MATCH_STARTED) {
    matchStatusName = '경기시작'
  } else if (timelineType === TimelineEventType.PERIOD_START) {
    if (timelineMatchStatus === MATCH_STATUS.GoldenSet
    || (MATCH_STATUS.Overtime <= timelineMatchStatus || timelineMatchStatus < MATCH_STATUS.Postponed)) {
      matchStatusName = `${advTimeline?.matchStatusName} 시작`
    } else {
      matchStatusName = `${getPeriodNameBySportId(sportId, advTimeline?.period)} 시작`
    }
  } else if (timelineType === TimelineEventType.BREAK_START
  && timelineMatchStatus === MATCH_STATUS.Break) {
    matchStatusName = `${getPeriodNameBySportId(sportId, advTimeline?.period)} 종료`
  } else {
    matchStatusName = advTimeline?.matchStatusName
  }

  return (
    <CheerForTeamListItem className="adv-timeline" key={advTimeline.id}>
      <div className="user-profile-btn">
        <div className="profile-img-wrap">
          <LogoWingIco/>
        </div>
      </div>
      <div className="contents-wrap">
        <div className="nick-name">
            승부사온라인 알리미
            <MatchStatusTag
              isTimeLine
              timeLineEventType={advTimeline.type}
              timelineEventTypeName={matchStatusName}
              dateOfMatch={advTimeline.time}
            />
            <p className="date">{formatCreatedAtToElapsedTime({
              createdAt: advTimeline.time,
              modifiedAt: null,
            })}</p>
          </div>
        <div className="contents">
          <p className="sport-talk-contents">{homeTeamName} {homeScore} : {awayScore} {awayTeamName}</p>
        </div>
      </div>
    </CheerForTeamListItem>
  )
})
